module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2.4rem",
      "margin-top": "0.6rem"
    }
  }, [_c('div', {
    staticClass: "labeldiv",
    staticStyle: {
      "margin-left": "2rem",
      "font-weight": "bold"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3rem",
      "margin-top": "2rem",
      "margin-left": "2rem",
      "margin-right": "2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "color": "#00469A"
    }
  }, [_vm._v("\n             吉凯基因淘基因致力于与您共享吉凯\" 工程化科研平台 \" 15年来积累的科研资源，为您提供优质的产品和服务\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "color": "#00469A"
    }
  }, [_vm._v("\n          如果您有任何建议或意见，可以通过以下方式联系我们：\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          电话："), _c('a', {
    attrs: {
      "href": "tel:400-621-0302"
    }
  }, [_vm._v("400-621-0302")])]), _vm._v(" "), _c('div', [_vm._v("\n          Email：service@genechem.com.cn\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          联系地址：上海市浦东新区爱迪生路332号\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4ae669e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Message/Contact.vue
// module id = 1737
// module chunks = 8